import React from 'react';
import {Filter, TextInput, FilterProps} from 'react-admin';

const FrameFilter = (props: Omit<FilterProps, 'children'>) => (
    <Filter {...props}>
        <TextInput source="matnr" alwaysOn/>
    </Filter>
);

export default FrameFilter;
